//Swiper from 'swiper/swiper-bundle';
var Swiper = require('swiper/swiper-bundle');
window.Swiper = Swiper;
import GLightbox from 'glightbox';
import IMask from 'imask';
import SmoothScroll from 'smooth-scroll';
import Lightpick from 'lightpick';
document.addEventListener('DOMContentLoaded', () => {
    const phoneMaskElements = document.querySelectorAll('.phone-mask');

    phoneMaskElements.forEach(element => {
        const maskOptions = {
            mask: '+{7}(000)000-00-00'
        };
        IMask(element, maskOptions);
    });
    // Инициализируйте SmoothScroll
    const scroll = new SmoothScroll('a[href*="#"]', {
        speed: 800,           // Скорость анимации в миллисекундах
        speedAsDuration: true, // Использовать ли скорость как длительность
        easing: 'easeInOutCubic', // Тип анимации (легкость)
        offset: -50,             // Смещение от верхнего края
        updateURL: false,      // Обновлять ли URL с якорем
    });
    const dateMaskInput = document.querySelector('.date-mask');

    if (dateMaskInput) {
        const picker = new Lightpick({
            field: dateMaskInput,
            format: 'DD.MM.YYYY',
            onSelect: function(date){
                dateMaskInput.value = date.format('DD.MM.YYYY');
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    var menuModalElement = document.getElementById('menuModal');
    var Modal = window.bootstrap && window.bootstrap.Modal;

    if (!menuModalElement || !Modal) {
        return;
    }

    var links = menuModalElement.querySelectorAll('a');
    var menuModal = Modal.getOrCreateInstance(menuModalElement);

    links.forEach(function(link) {
        link.addEventListener('click', function() {
            menuModal.hide();
        });
    });
});

(function() {

    window.addEventListener('load', function() {
        document.body.classList.add('page-loaded');



    });
    $(document).ready(function() {
        var active;

        active = true;

        $('#navicon').click(function() {
            if (active === true) {
                $('#navicon').removeClass('inactive').addClass('active');
                active = false;
                //return console.log(active);
            } else {
                $('#navicon').removeClass('active').addClass('inactive');
                active = true;
                //return console.log(active);
            }
        });
        if ($('#menuModal').length) {
            $('#menuModal').on('hide.bs.modal', function () {
                $('#navicon').removeClass('active').addClass('inactive');
                active = true;
            });
        }

        const headers = document.querySelectorAll('.price-item header');
        headers.forEach(header => {
            header.addEventListener('click', () => {
                const arrow = header.querySelector('.arrow');
                const details = header.nextElementSibling;
                arrow.classList.toggle('rotate');
                details.classList.toggle('show');
            });
        });
       /* const customLightboxHTML = `<div id="glightbox-body" class="glightbox-container">
            <div class="gloader visible"></div>
            <div class="goverlay"></div>
            <div class="gcontainer">
            <div id="glightbox-slider" class="gslider"></div>
            <button class="gnext gbtn" tabindex="0" aria-label="Next" data-customattribute="example"><img src="/images/arrow-right.svg" alt=""></button>
            <button class="gprev gbtn" tabindex="1" aria-label="Previous"><img src="/images/arrow-left.svg" alt=""></button>
            <button class="gclose gbtn" tabindex="2" aria-label="Close"><img src="/images/close_x.svg" alt=""></button>
        </div>
        </div>`;
        const lightbox = GLightbox({
            loop: true,
            lightboxHTML: customLightboxHTML,
            selector: ".glightbox3",
            openEffect: "zoom",
            closeEffect: "fade",
            startAt: 0,
            closeOnOutsideClick: true,
            zoomable: true,
            width: "100vw",
            height: "100vh"
        });
        const categoryList = $("#publishing_national");
        const showMoreButton = $("#publishing_national_show_more");

        $(showMoreButton).on("click", function() {
            const showCount = parseInt(categoryList.data("show"), 10);
            const hiddenItems = categoryList.find(".hidden");

            hiddenItems.slice(0, showCount).removeClass("hidden");

            if (hiddenItems.length <= showCount) {
                showMoreButton.hide();
            }
        });*/
    });
    $('img.svg').each(function () {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        $.get(imgURL, function (data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            $svg.find('svg *').removeAttr('clip-path');
            // Replace image with new SVG
            $img.replaceWith($svg);

        }, 'xml');
    });
})();
